export const uploadFileNDA = 'Upload/UploadFileNDA';